import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import { MdLock } from '../../utils/icons';
import './AccessDenied.css';

interface AccessDeniedProps {
  /** The role the user was missing — shown to help support/self-service. */
  requiredRole?: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ requiredRole }) => {
  const navigate = useNavigate();

  return (
    <Layout title="Access Denied">
      <div className="access-denied">
        <div className="access-denied-icon">
          <MdLock aria-hidden="true" />
        </div>
        <h2 className="access-denied-title">You don’t have access to this area</h2>
        <p className="access-denied-desc">
          Your account isn’t assigned the permission required for this page.
          Access is managed through Microsoft Entra ID groups — ask your
          administrator to add you to the appropriate STEP ProductLinQ group.
        </p>
        {requiredRole && (
          <p className="access-denied-role">
            Required permission: <code>{requiredRole}</code>
          </p>
        )}
        <button className="access-denied-btn" onClick={() => navigate('/dashboard', { replace: true })}>
          Back to Dashboard
        </button>
      </div>
    </Layout>
  );
};

export default AccessDenied;
